/**
 * @desc 获取当前登录用户的剩余可申请SN码数量
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierAccountBoxInfo/getSnAvailableNum`, {
      method: "GET",

      ...options,
    }),
  );
}
